import Rails from "@rails/ujs";

Rails.start();

import { initSentry } from "@/sentry";
initSentry();

import { I18n } from "@/i18n/i18n";

// bootstrap
import { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip } from "bootstrap";
window.bootstrap = { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip };

import { Drawer } from "@/drawer";
import { Toast } from "@/toast";
import { Notification, initNotifications } from "@/notification";
import {
    checkTimeZone,
    checkIframe,
    initTooltips,
    setHTMLExecuteScripts,
    replaceHTMLExecuteScripts,
    katexOptions,
} from "@/utilities";
import { FaviconManager } from "@/favicon";
import { themeState } from "@/state/Theme";
import { initThemeMenu } from "@/theme_menu";
import "@/components/saved_annotations/saved_annotation_list";
import { userState } from "@/state/Users";
import "@/components/series_icon";
import "@/components/copy_container";
import "@/components/datalist_input";
import "@/components/markdown_editor";
import "@/components/time_ago";

// Use a global dodona object to prevent polluting the global na
const dodona = window.dodona || {};
dodona.katexOptions = katexOptions;
dodona.dotManager = new FaviconManager(dodona.dotCount || []);
dodona.checkTimeZone = checkTimeZone;
dodona.Toast = Toast;
dodona.Notification = Notification;
dodona.initNotifications = initNotifications;
dodona.initTooltips = initTooltips;
dodona.checkIframe = checkIframe;
dodona.setHTMLExecuteScripts = setHTMLExecuteScripts;
dodona.replaceHTMLExecuteScripts = replaceHTMLExecuteScripts;
dodona.initTheme = (theme) => themeState.initTheme(theme);
dodona.setUserId = (userId) => (userState.id = userId);
dodona.I18n = I18n;
window.dodona = dodona;

// Init drawer
dodona.ready.then(() => {
    if (document.getElementById("drawer") !== null) {
        new Drawer();
    }
});

dodona.ready.then(initTooltips);
dodona.ready.then(initThemeMenu);
